import React from "react";
import { AppBarContext } from "../AppBarContext";
import { AppBarContextType } from "../AppBarContext.types";
const useAppBarContext = (): AppBarContextType => {
  return React.useContext<AppBarContextType>(AppBarContext);
};
export default useAppBarContext;
